import { SkeletonText } from 'carbon-components-react'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { OverflowMenu, OverflowMenuItem } from '../../../../OverflowMenu'
import { NAV_MENU_ITEM } from '../constant'

export const ItemMenu = (
  item,
  parentTitle,
  onlyGroupLink,
  Components,
  onClickItem,
  type,
  pathname,
  isSideNavExpanded,
  idx,
  dragStartItem,
  dragEnterItem,
  dropItem,
  navMenuIndex,
  enableDragAndDrop
) => {
  const { Item, Counter } = Components
  const props = enableDragAndDrop
    ? {
        draggable: enableDragAndDrop,
        onDragStart: (e) => dragStartItem(e, idx),
        onDragEnter: (e) => dragEnterItem(e, idx, item.groups),
        onDragEnd: (e) => dropItem(e, navMenuIndex, NAV_MENU_ITEM, item.groups)
      }
    : {
        draggable: false
      }
  return (
    <Item
      {...props}
      key={item.groups || item.id}
      id={'BDD_' + item.id}
      to={item.href}
      onClick={() => onClickItem(item)}
      className={`ublique-${type}-navigation-items-item`}
      {...(type === 'sidebar' && {
        renderIcon: item.icon,
        isActive: item.href === pathname
      })}
      element={({ children, ...linkProps }) => {
        return (
          <Fragment>
            <Link {...linkProps}>
              {children}
              {item.count ? <Counter length={item.count} /> : null}
            </Link>
            {type === 'sidebar' &&
              (item.actions ? (
                <OverflowMenu
                  flipped
                  menuOptionsClass='ublique-sidebar-overflow-menu'
                >
                  {item.actions.map((action, i) => (
                    <OverflowMenuItem
                      key={action.id || i}
                      onClick={action.onClick}
                      itemText={action.title}
                    />
                  ))}
                </OverflowMenu>
              ) : (
                <OverflowMenu className='overflow-menu-visually-hidden' />
              ))}
          </Fragment>
        )
      }}
    >
      {item.loading ? (
        <SkeletonText width={isSideNavExpanded ? '14rem' : '1rem'} />
      ) : parentTitle && onlyGroupLink ? (
        parentTitle
      ) : (
        item.title
      )}
    </Item>
  )
}
